import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["form", "errors", "files", "previews", "button", "success", "captchaToken", "captchaAnswer", "captchaQuestion"]

  connect() { this.urls = [] }

  validateMethods() {
    const inputs = this.formTarget.querySelectorAll("input[type='checkbox']")
    inputs[0].setCustomValidity(Array.from(inputs).some(input => input.checked) ? "" : "Выберите хотя бы один способ связи.")
  }

  preview() {
    this.clearPreviews()
    const files = Array.from(this.filesTarget.files)
    const invalid = files.length > 5 || files.some(file => !["image/jpeg", "image/png", "image/webp"].includes(file.type) || file.size > 5 * 1024 * 1024) || files.reduce((sum, file) => sum + file.size, 0) > 10 * 1024 * 1024
    this.filesTarget.setCustomValidity(invalid ? "До 5 фото JPG, PNG или WebP: каждое до 5 МБ, все вместе до 10 МБ." : "")
    if (invalid) { this.filesTarget.reportValidity(); return }
    files.forEach(file => {
      const image = document.createElement("img")
      const url = URL.createObjectURL(file)
      this.urls.push(url)
      image.src = url
      image.alt = file.name
      this.previewsTarget.append(image)
    })
  }

  async submit(event) {
    event.preventDefault()
    event.stopPropagation()
    if (this.sending) return
    this.validateMethods()
    if (!this.formTarget.reportValidity()) return
    this.sending = true
    this.buttonTarget.disabled = true
    this.buttonTarget.value = "Отправляем…"
    this.errorsTarget.hidden = true
    this.abort = new AbortController()
    try {
      const response = await fetch(this.formTarget.action, {
        method: "POST", body: new FormData(this.formTarget), signal: this.abort.signal,
        headers: {Accept: "application/json", "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || ""}
      })
      if (!response.headers.get("content-type")?.includes("application/json")) throw new Error("Не удалось отправить заявку. Попробуйте ещё раз.")
      const result = await response.json()
      if (!response.ok) {
        if (result.captcha_token) {
          this.captchaTokenTarget.value = result.captcha_token
          this.captchaQuestionTarget.textContent = result.captcha_question
          this.captchaAnswerTarget.value = ""
        }
        this.errorsTarget.textContent = (result.errors || ["Не удалось отправить заявку."]).join(" · ")
        this.errorsTarget.hidden = false
        this.errorsTarget.scrollIntoView({block: "nearest"})
        return
      }
      this.formTarget.reset()
      const token = this.formTarget.querySelector("input[name='callback_request[submission_token]']")
      token.value = token.defaultValue = result.submission_token
      this.formTarget.hidden = true
      this.successTarget.hidden = false
      this.clearPreviews()
    } catch (error) {
      if (error.name !== "AbortError") {
        this.errorsTarget.textContent = "Не удалось отправить заявку. Проверьте соединение и повторите — дубль не создастся."
        this.errorsTarget.hidden = false
      }
    } finally {
      this.sending = false
      this.buttonTarget.disabled = false
      this.buttonTarget.value = "Отправить заявку"
    }
  }

  again() {
    window.location.assign(this.formTarget.action + "/new")
  }

  clearPreviews() {
    this.urls.forEach(url => URL.revokeObjectURL(url))
    this.urls = []
    this.previewsTarget.replaceChildren()
  }

  disconnect() {
    this.abort?.abort()
    this.clearPreviews()
  }
}
